import React from "react";
import { Badge } from "shards-react";

function printType(user) {
  if (user.type === "admin") {
    return <Badge theme="warning">administrador</Badge>;
  }
  if (user.type === "consumer") {
    return <Badge theme="primary">consumidor</Badge>;
  }
  if (user.type === "producer") {
    return <Badge theme="secondary">productor</Badge>;
  }
  if (user.type === "undefined") {
    return <Badge theme="danger">no definido</Badge>;
  }
  return <Badge theme="danger">{user.type}</Badge>;
}

export { printType };
